import { gql } from '@apollo/client';
import RESOURCE_FRAGMENT from '../../fragments/resource';

const GET_RESOURCES = gql`
  query ($where: ResourcesWhereInput) {
    resources(where: $where) {
      ...BaseResource
    }
  }
  ${RESOURCE_FRAGMENT}
`;

export default GET_RESOURCES;
